<template>
  <div>
    <MapRawSource :id="id" :source="source" v-if="mounted">
      <MapRawLayer
        v-for="(layer, index) in layers"
        :layer="{ id: `${id}-${index}`, ...layer, source: id }"
        :key="layer.id"
      />
    </MapRawSource>
  </div>
</template>
<script lang="ts" setup>
import type {
  AnyLayer,
  BackgroundLayer,
  CustomLayerInterface,
  GeoJSONSourceRaw,
  Style,
} from "mapbox-gl";
import type { RawLayer } from "~~/../shared/components/map/RawLayer.vue";

const mounted = ref(false);
onMounted(() => (mounted.value = true));
onBeforeUnmount(() => (mounted.value = false));

const props = defineProps<{
  geojson: GeoJSONSourceRaw["data"];
  layers?: (Omit<RawLayer, "id"> & { id?: string })[];
}>();

const id = `test-${Math.random()}`;

const source = computed<GeoJSONSourceRaw>(() => ({
  type: "geojson",
  data: props.geojson,
}));
</script>
